module.exports = __webpack_public_path__ + "img/dafc859.jpg";